"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IAFormatter = void 0;
const echain_shared_form_validation_1 = require("@igus/echain-shared-form-validation");
const echain_shared_i18n_1 = require("@igus/echain-shared-i18n");
const echain_shared_quantities_1 = require("@igus/echain-shared-quantities");
const IAFormValidator_1 = require("./IAFormValidator");
class IAFormatter {
    static breite(options) {
        const basicOptions = Object.assign({}, options, {
            roundType: echain_shared_form_validation_1.RoundType.ROUND,
            unit: options.unitSystem === echain_shared_i18n_1.UnitSystem.metric ? echain_shared_quantities_1.LengthUnits.mm : echain_shared_quantities_1.LengthUnits.inch,
            precision: options.unitSystem === echain_shared_i18n_1.UnitSystem.metric ? 0 : 2,
        });
        return new echain_shared_form_validation_1.BasicQuantityFormatter(basicOptions);
    }
    static fussbreite(options) {
        return IAFormValidator_1.IAFormValidator.fussbreite(options);
    }
    static abstand(options) {
        return IAFormValidator_1.IAFormValidator.abstand(options);
    }
}
exports.IAFormatter = IAFormatter;
//# sourceMappingURL=IAFormatter.js.map